import { useMemo } from "react";
import { useSelector } from "react-redux";

import { dataMetaSelector } from "Bands/state";
import { USER_ACTIONS } from "Bands/types";
import { IAPIState } from "shared/types";

export const useFetchingContactDetails = () => {
  const { api: addressApi } = useSelector(
    dataMetaSelector(USER_ACTIONS.getUserAddresses)
  );
  const { api: phoneApi } = useSelector(
    dataMetaSelector(USER_ACTIONS.getUserPhoneNumbers)
  );
  const { api: contactApi } = useSelector(
    dataMetaSelector(USER_ACTIONS.getUserEmergencyContacts)
  );
  const { api: baseApi } = useSelector(
    dataMetaSelector(USER_ACTIONS.getUserHomeBases)
  );

  const fetchingAddresses = useMemo(() => {
    return addressApi?.status === IAPIState.pending;
  }, [addressApi]);

  const fetchingPhoneNumbers = useMemo(() => {
    return phoneApi?.status === IAPIState.pending;
  }, [phoneApi]);

  const fetchingEmergencyContacts = useMemo(() => {
    return contactApi?.status === IAPIState.pending;
  }, [contactApi]);

  const fetchingHomeBases = useMemo(() => {
    return baseApi?.status === IAPIState.pending;
  }, [baseApi]);

  const fetchingContactDetails = useMemo(() => {
    return (
      fetchingAddresses ||
      fetchingPhoneNumbers ||
      fetchingEmergencyContacts ||
      fetchingHomeBases
    );
  }, [
    fetchingAddresses,
    fetchingPhoneNumbers,
    fetchingEmergencyContacts,
    fetchingHomeBases,
  ]);

  return {
    fetchingAddresses,
    fetchingPhoneNumbers,
    fetchingEmergencyContacts,
    fetchingHomeBases,
    fetchingContactDetails,
  };
};
